import request from '@/utils/request';

const brandApi = {
    getToken(brandId){
        return request({
            url: '/app/login/client',
            method: 'post',
            data: {
                'brandId':brandId, // 品牌ID
            }
        })
    },
    // 报告查询订单提交
    orderSubmit(userPromotionId,consumerPhone,consumerUserName,consumerIdCard,authCode,{isNeedAuthCode = ''}){
        return request({
            url: '/app/product/order/submit',
            method: 'post',
            data: {
                'type':'1', // 类型(1:大数据,2:信用卡,3:会员权益,4:话费充值,5:闪客联盟)
                'userPromotionId': userPromotionId, // 产品用户推广配置ID
                'consumerPhone': consumerPhone, // 消费者手机号
                'consumerUserName': consumerUserName, // 消费者姓名
                'consumerIdCard': consumerIdCard, // 消费者身份证号码
                'authCode': authCode, // 验证码
                'isNeedAuthCode': isNeedAuthCode, // 是否需要短信验证码(传1表示需要)
            }
        })
    },
    // 报告查询订单支付
    orderPay(orderCode,payType){
        return request({
            url: '/app/product/order/pay',
            method: 'post',
            data: {
                'orderCode': orderCode, // 提交订单后返回的订单号
                'payType': payType, // 支付方式，1：支付宝，2：微信
            }
        });
    },
    // 查询产品订单详情
    queryReportOrderDetails({brandId,orderCode,payOrderCode,orderType = '1',consumerPhone,consumerUserName,consumerIdCard}){
        return request({
            url: '/app/query/product/order/details',
            method: 'post',
            data: {
                'brandId': brandId,
                'orderCode': orderCode,  // 订单号
                'payOrderCode': payOrderCode, // 支付订单号
                'orderType': orderType, // 订单类型(1:大数据,2:信用卡,3:会员权益,4:话费充值,5:闪客联盟)
                'consumerPhone': consumerPhone, // 消费者手机号
                'consumerUserName': consumerUserName, // 消费者姓名，支持模糊查询
                'consumerIdCard': consumerIdCard, // 消费者身份证号码，支持模糊查询
            }
        })
    },
    // 获取新闻列表数据
    queryAppInforMtion({infoType,title,isTop,isLike,page,size,id}){
        return request({
            url: '/app/query/app/info',
            method: 'post',
            data: {
                'infoType': infoType, // 类型，1、轮播图，2：快讯，3：深度资讯，4：分享海报，5：首页公告，6：活动中心
                'title': title, // 标题
                'page':page,
                'size':size,
                'isTop':isTop, // 是否置顶
                'isLike': isLike, // 是否显示点赞
                'id': id,
            }
        })
    },
    // 提交信用卡申请
    applyCardRecord(name,bankName,idCard,phone){
        return request({
            url: '/app/add/apply/card/record',
            method: 'post',
            data: {
                'name': name, // 姓名
                'bankName': bankName, // 银行名称
                'idCard': idCard, // 身份证号码
                'phone': phone,
            }
        })
    },
    // 获取缓存的请求参数
    getRequestParams(key){
        return request({
            url: '/open/api/query/request/param',
            method: 'post',
            data: {
                'key': key,
            }
        })
    },
    // 获取图形验证码
    getCaptcha({account}){
        return request({
            url: '/app/get/captcha',
            method: 'post',
            data: {
                'account': account, // 验证的账号、手机号
            }
        })
    },
    // 校验图形验证码
    checkCaptcha(){
        return request({
            url: '/app/check/captcha',
            method: 'post',
            data: {}
        })
    },
    // 获取通道配置
    getChannel(isOn,{channelName,channelTag,size = 99,brandId}){
        return request({
            url: '/app/query/pay/channel/config',
            method: 'post',
            data: {
                'isOn': isOn, // 是否开启，1：是，0：否
                'channelName': channelName, // 通道名称
                'channelTag': channelTag, // 通道标识
                'size':size,
                'page': 0,
                'brandId': brandId
            }
        });
    },
    // 获取品牌配置
    getBrandConfig(){
        return request({
            url: '/app/query/brand/config',
            method: 'post', 
            data: {
                'isGroup': 1,
            }
        });
    }
}

export default brandApi;